import Vue from 'vue'
import Vuex from 'vuex'
import SDK from '@yxim/nim-web-sdk'
import nimActions from './nimActions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    visible: false,
    imgPath: process.env.NODE_ENV === 'development' ? 'http://wx.qyh.com/storage/' : 'https://weixin.qiyehuo.com/storage/',
    serverUrl: process.env.NODE_ENV === 'development' ? 'http://wx.qyh.com:8080/api/UEditor' : 'https://weixin.qiyehuo.com/api/UEditor',
    serverUrlStudy: process.env.NODE_ENV === 'development' ? 'http://wx.qyh.com/api/SEditor' : 'https://weixin.qiyehuo.com/api/SEditor',
    PortraitPath: process.env.NODE_ENV === 'development' ? 'http://wx.qyh.com/api/storage' : 'https://weixin.qiyehuo.com/storage/',
  //  http://wx.qyh.com/api/UEditor
  //  http://wx.qyh.com/storage/
    collapse: true,
    // currentMenuItem: '/'
    userStore: {},
    windowHostStore: {},
    imVisible: false,
    imFullscreen: false,
    imWinCreateTeamVisible: false,
    imShowChatInfoVisible: false,
    imTeamMemberAddVisible: false,
    imTeamMemberRemoveVisible: false,
    imTeamMemberCheckList: [],
    imTeamAddMemberCheckList: [],
    imLeftActiveName: 'chat',
    nim: null,
    imConnectionId: null,
    imAccount: {},
    imUserProfiles: {},
    imAccountFriends: [],
    imActiveAccount: {},
    imSessionMap: [],
    imSessions: [],
    imSessionMsgs: {},
    imMessages: [],
    botFollowUp: [],
    botChunkIng: false,
    imMsgListToBottom: false,
    imMsgListToTop: false,
    imActiveContact: {},
    imActiveContactType: '',
    imUnreadCount: 0,
    imQyhContactData: [],
    imTeams: {},
    imTeamsArr: [],
    imConfirm: {
      visible: false,
      message: '',
      resolve: null,
      reject: null
    },
    imSetWinVisible: false
  },
  actions: {
    ...nimActions,
    openHeadForm (ctx, visible) {
      ctx.commit('openHeadForm', visible)
    },
    hideHeadForm (ctx, visible) {
      ctx.commit('hideHeadForm', visible)
    },
    setCollapse (ctx, collapse) {
      ctx.commit('setCollapse', collapse)
    },
    // setMenuItem (ctx, currentMenuItem) {
    //   ctx.commit('setMenuItem', currentMenuItem)
    // }
    createUserStoreAction (ctx, user) {
      ctx.commit('createUserStoreMutation', user)
    },
    createWindowHostStoreAction (ctx, createData) {
      ctx.commit('createWindowHostStoreMutation', createData)
    },
    updateWindowHostStoreAction (ctx, updatedData) {
      ctx.commit('updateWindowHostStoreMutation', updatedData)
    },
    removeWindowHostStoreAction (ctx, idx) {
      ctx.commit('removeWindowHostStoreMutation', idx)
    },
    showImWindowStoreAction (ctx, visible) {
      ctx.commit('showImWindowStoreMutation', visible)
    },
    changeImFullscreenStoreAction (ctx, fullscreen) {
      ctx.commit('changeImFullscreenStoreMutation', fullscreen)
    },
    changeImAccountStoreAction (ctx, account) {
      ctx.commit('changeImAccountStoreMutation', account)
    },
    setImAccountFriendsStoreAction (ctx, friends) {
      ctx.commit('setImAccountFriendsStoreMutation', friends)
    },
    changeImActiveAccountAction (ctx, account) {
      ctx.commit('changeImActiveAccountMutation', account)
    },
    addImUnreadCountAction (ctx, num) {
      ctx.commit('addImUnreadCountMutation', num)
    },
    reduceImUnreadCountAction (ctx, num) {
      ctx.commit('reduceImUnreadCountMutation', num)
    },
    refreshImUnreadCountAction (ctx, num) {
      ctx.commit('refreshImUnreadCountMutation', num)
    },
    changeImWinCreateTeamVisibleAction (ctx, visible) {
      ctx.commit('changeImWinCreateTeamVisibleMutation', visible)
    },
    changeImShowChatInfoVisibleAction (ctx, visible) {
      ctx.commit('changeImShowChatInfoVisibleMutation', visible)
    },
    changeImTeamMemberAddVisibleAction (ctx, visible) {
      ctx.commit('changeImTeamMemberAddVisibleMutation', visible)
    },
    changeImTeamMemberRemoveVisibleAction (ctx, visible) {
      ctx.commit('changeImTeamMemberRemoveVisibleMutation', visible)
    },
    changeImTeamMemberCheckListAction (ctx, list) {
      ctx.commit('changeImTeamMemberCheckListMutation', list)
    },
    changeImTeamAddMemberCheckListAction (ctx, list) {
      ctx.commit('changeImAddTeamMemberCheckListMutation', list)
    },
    imQyhContactDataAction (ctx, data) {
      ctx.commit('imQyhContactDataMutation', data)
    },
    imConnectionIdAction (ctx, connectionId) {
      ctx.commit('imConnectionIdMutation', connectionId)
    },
    changeImSetWinVisibleAction (ctx, visible) {
      ctx.commit('changeImSetWinVisible', visible)
    }
  },
  mutations: {
    openHeadForm (state, visible) {
      state.visible = visible
    },
    hideHeadForm (state, visible) {
      state.visible = visible
    },
    setCollapse (state, collapse) {
      state.collapse = collapse
    },
    // setMenuItem (state, currentMenuItem) {
    //   state.currentMenuItem = currentMenuItem
    // }
    createUserStoreMutation (state, user) {
      state.userStore = user
    },
    createWindowHostStoreMutation (state, createData) {
      Vue.set(state.windowHostStore, createData.client_route, createData)
    },
    updateWindowHostStoreMutation (state, updatedData) {
      state.windowHostStore = updatedData
    },
    removeWindowHostStoreMutation (state, idx) {
      Vue.delete(state.windowHostStore, idx)
    },
    showImWindowStoreMutation (state, visible) {
      state.imVisible = visible
    },
    changeImFullscreenStoreMutation (state, fullscreen) {
      state.imFullscreen = fullscreen
    },
    changeImLeftActiveNameStoreMutation (state, activeName) {
      state.imLeftActiveName = activeName
    },
    setNimInstance (state, nimInstance) {
      state.nim = nimInstance
    },
    changeImAccountStoreMutation (state, account) {
      state.imAccount = account
    },
    setImAccountFriendsStoreMutation (state, friendsS) {
      state.imAccountFriends = friendsS
    },
    changeImActiveAccountMutation (state, account) {
      state.imActiveAccount = account
    },
    addImUserProfilesMutation (state, user) {
      Vue.set(state.imUserProfiles, user.account, user)
    },
    setImOrderSessionsMutation (state, sessions) {
      state.imSessions = sessions
    },
    setImSessionMapMutation (state, session) {
      state.imSessionMap[session.id] = session
    },
    refreshImSessionMapMutation (state, newMap) {
      state.imSessionMap = newMap
    },
    removeImSessionMsgMutation (state, sessionId) {
      Vue.delete(state.imSessionMsgs, sessionId)
    },
    setImSessionMsgMutation (state, { sessionId, sessionMsg }) {
      Vue.set(state.imSessionMsgs, sessionId, sessionMsg)
    },
    updateFetchingMutation (state, { sessionId, fetching }) {
      state.imSessionMsgs[sessionId].fetching = fetching
    },
    updateMsgArrMutation (state, { sessionId, msgArr }) {
      state.imSessionMsgs[sessionId].msgArr = msgArr
    },
    updateCompleteMutation (state, { sessionId, complete }) {
      state.imSessionMsgs[sessionId].complete = complete
    },
    setImMessageMutation (state, msgArr) {
      state.imMessages = msgArr
    },
    addImMessageMutation (state, msg) {
      state.imMessages.push(msg)
    },
    addBotFollowUpMutation (state, msg) {
      state.botFollowUp.push(msg)
    },
    setBotFollowUpMutation (state, arr) {
      state.botFollowUp = arr
    },
    setBotChunkIngMutation (state, botChunkIng) {
      state.botChunkIng = botChunkIng
    },
    imMsgListToBottomMutation (state, toBottom) {
      state.imMsgListToBottom = toBottom
    },
    imMsgListToTopMutation (state, toTop) {
      state.imMsgListToTop = toTop
    },
    changeImActiveContactMutation (state, { account, type }) {
      state.imActiveContact = account
      state.imActiveContactType = type
    },
    setImMsgReadyMutation (state, option) {
      const message = state.imMessages[option.i]
      if (message) {
        Vue.set(message, 'readByOtherUser', true)
      }
    },
    addImUnreadCountMutation (state, num) {
      state.imUnreadCount += num
    },
    reduceImUnreadCountMutation (state, num) {
      state.imUnreadCount -= num
    },
    refreshImUnreadCountMutation (state, num) {
      state.imUnreadCount = num
    },
    changeImWinCreateTeamVisibleMutation (state, visible) {
      state.imWinCreateTeamVisible = visible
    },
    changeImShowChatInfoVisibleMutation (state, visible) {
      state.imShowChatInfoVisible = visible
    },
    changeImTeamMemberAddVisibleMutation (state, visible) {
      state.imTeamMemberAddVisible = visible
    },
    changeImTeamMemberRemoveVisibleMutation (state, visible) {
      state.imTeamMemberRemoveVisible = visible
    },
    changeImTeamMemberCheckListMutation (state, list) {
      state.imTeamMemberCheckList = list
    },
    changeImAddTeamMemberCheckListMutation (state, list) {
      state.imTeamAddMemberCheckList = list
    },
    imQyhContactDataMutation (state, data) {
      state.imQyhContactData = data
    },
    setImQyhContactDataMutation (state, { account, index }) {
      Vue.set(state.imQyhContactData, index, account)
    },
    imConnectionIdMutation (state, connectionId) {
      state.imConnectionId = connectionId
    },
    addImTeamMutation (state, team) {
      Vue.set(state.imTeams, team.teamId, team)
    },
    removeImTeamMutation (state, teamId) {
      Vue.delete(state.imTeams, teamId)
    },
    addImTeamArrMutation (state, team) {
      state.imTeamsArr.push(team)
    },
    setImTeamArrMutation (state, teams) {
      state.imTeamsArr = teams
    },
    SHOW_IM_CONFIRM (state, payload) {
      state.imConfirm.visible = true
      state.imConfirm.message = payload.message
      state.imConfirm.resolve = payload.resolve
      state.imConfirm.reject = payload.reject
    },
    HIDE_CONFIRM (state) {
      state.imConfirm.visible = false
      state.imConfirm.message = ''
      state.imConfirm.resolve = null
      state.imConfirm.reject = null
    },
    changeImSetWinVisible (state, visible) {
      state.imSetWinVisible = visible
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js